import type { SystemPermission } from '../../context';
import { toQuestionnaireTO, type QuestionnaireTO } from './Questionnaire';

export class TenancyTO {
  tenancy_id!: number;
  tenancy_name?: string;
  features?: Record<string, any>;
  permissionsSetup?: boolean;
  questionnaires?: QuestionnaireTO[];
  userPermissions?: Record<SystemPermission, boolean>;
  lastImportBySource?: Record<string, string>;
}

export const toTenancyTO = (tenancy: any): TenancyTO => {
  return {
    tenancy_id: tenancy.tenancy_id,
    tenancy_name: tenancy.tenancy_name,
    features: tenancy.features,
    permissionsSetup: tenancy.permissionsSetup,
    questionnaires: (tenancy.questionnaires || []).map(toQuestionnaireTO),
    userPermissions: tenancy.userPermissions,
    lastImportBySource: tenancy.last_import_by_source,
  };
};

export type ClinicianProfileFieldType =
  | 'text'
  | 'number'
  | 'date'
  | 'select'
  | 'multiSelect'
  | 'radio'
  | 'checkbox';

export type ClinicianProfileFieldKey =
  | 'medicineProfilePhoneNumber'
  | 'medicineProfilePagerNumber';

export interface ClinicianProfileFieldTO {
  title: string;
  key: ClinicianProfileFieldKey;
  type: ClinicianProfileFieldType;
}

export const toClinicianProfileFieldTO = (
  field: any,
): ClinicianProfileFieldTO => {
  return {
    ...field,
  };
};
